import qs from 'qs';
import { useCallback } from 'react';

type QueryParamScalar = string | number | boolean;

export type QueryParams = Record<string, QueryParamScalar | readonly QueryParamScalar[] | null | undefined>;

export function useQueryString(searchParams: URLSearchParams) {
  const createQueryString = useCallback(
    (params: QueryParams) => {
      const existingParams = qs.parse(searchParams.toString(), { ignoreQueryPrefix: true });

      const cleanedParams = Object.fromEntries(
        Object.entries({ ...existingParams, ...params }).filter(([, value]) => value !== null && value !== undefined),
      );

      const queryString = qs.stringify(cleanedParams, {
        addQueryPrefix: false,
        encode: false,
        arrayFormat: 'brackets',
      });

      return queryString;
    },
    [searchParams],
  );

  return { createQueryString };
}
